import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { reviewerTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { splitKey } from '../../constants/KolTags';
import { useFrontWebConfig } from '@op/hooks/useFrontWebConfig';

export default function KolTagsSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const options = useFrontWebConfig({ keys: 'kol_tags_filter' });

  const tagOptions = useMemo(() => { 
    const isEN = lang === 'en-US';
    return options.map((val: { text: string; textCN: string; value: string }) => {
      const textEN = val?.text || val?.textCN;
      const textCN = val?.textCN || val?.text;
      const text = isEN ? textEN : textCN;
      return {
        text,
        value: val?.value,
      };
    });
  }, [options, formatMessage]);

  const {
    selects: kolTags,
    setSelects: setKolTags,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'kol_tags',
    mustFilter: false,
    options: tagOptions.map((item) => item.value),
    finallyDealwithSelected: (selected, options = []) => {
      const result: Array<string> = [];

      selected.forEach((element) => {
        options.forEach((item) => {
          if (item.includes(element) && !result.includes(item)) {
            result.push(item);
          }
        });
      });
      return result;
    },
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();

    const value = kolTags.map((key) => key.split(splitKey)).flat(2);

    // 只有单选Others才需要excludeKolTags
    const notOthers = options?.filter(
      (item: { text: string }) => item.text !== 'Others',
    );
    const hasAnyIncluded =
      value.length === 0 ||
      notOthers.some((item: { value: string }) => value?.includes(item.value));
    const excludeKolTags = hasAnyIncluded
      ? []
      : notOthers.map((val: { value: string }) => val.value);

    onChange?.(
      'kol_tags',
      commonBackInfo(
        { kol_tags: value, exclude_kol_tags: excludeKolTags },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll, defaultValue: [] },
      ),
    );
  }, [kolTags, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomSelect
        ref={customSelectRef}
        matchButtonWidth={false}
        placeholderText={reviewerTypePlaceholder[lang]}
        onClear={() => setKolTags([])}
        selectOptionsInfo={[kolTags, setKolTags]}
        options={tagOptions}
        pointKey={FilterButtonPoint.kolTags}
      ></CustomSelect>
    </div>
  );
}
